import React from 'react';
import StatsPanel from '../components/progress/StatsPanel';

export default function ProgressView() {
  return <StatsPanel />;
}